import { useEffect } from 'react';
import {
  RelationsParams,
  RelationsResponse,
} from 'src/apis/contract-management/types';
import { useAxios } from 'src/hooks/use-axios';
import { Forbidden } from 'src/utils/errors';
import urlTemplate from 'url-template';

type RequestOptions = {
  url?: string;
  params?: RelationsParams;
};

export function useOperatorRelations({ url, params }: RequestOptions) {
  const relations = useAxios(
    (axios, signal, { url, params }: RequestOptions) => {
      if (!url) throw new Forbidden();

      return axios.request<RelationsResponse>({
        signal,
        url: urlTemplate.parse(url).expand({}),
        params,
      });
    },
    {
      neededOnPageLoad: true,
      onError(error) {
        if (error instanceof Forbidden) {
          return error;
        } else {
          throw error;
        }
      },
    }
  );
  useEffect(() => {
    relations.execute({ url, params });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, params]);

  return relations;
}

export type RelationsRequest = ReturnType<typeof useOperatorRelations>;
